module.exports = __webpack_public_path__ + "static/blue-flower-logo-2df548730b4645a13c2f7ebc29a1f2e0.png";